import { onBeforeRouteLeave } from 'vue-router';
import { onScopeDispose } from 'vue';

type RouteLockGuard = () => Promise<boolean>;

interface LockOptions {
	onLeave?: () => void;
}

const activeGuards = new Set<RouteLockGuard>();
let bypassRouteLeaveGuard = false;

export function useLockRoute() {
	function lockRoute(guard: RouteLockGuard, options?: LockOptions) {
		activeGuards.add(guard);

		onScopeDispose(() => {
			activeGuards.delete(guard);
		});

		onBeforeRouteLeave(async (to, from, next) => {
			if (bypassRouteLeaveGuard) {
				options?.onLeave?.();
				next();

				bypassRouteLeaveGuard = false;
				return;
			}

			const canLeave = await guard();
			if (!canLeave) {
				next(false);
				return;
			}

			options?.onLeave?.();
			next();
		});
	}

	async function requestLeave(): Promise<boolean> {
		for (const guard of activeGuards) {
			const canLeave = await guard();
			if (!canLeave) return false;
		}
		bypassRouteLeaveGuard = true;
		return true;
	}

	return { lockRoute, requestLeave };
}
